const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
export const API = `${BACKEND_URL}/api`;

export const IS_TEST = typeof window !== 'undefined' && window.__TEST__;

// Development mode detection - process.env.NODE_ENV is set by CRA/Webpack
// Also check for localhost as fallback
export const IS_DEV = typeof window !== 'undefined' && (
    process.env.NODE_ENV === 'development' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
);
